import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Glide from '@glidejs/glide'; // https://glidejs.com/docs/options/

class ItemSlider extends WebComponent {
  constructor(props) {
    super(props);
    this.itemSlider = null;
    this.arrowLeft = null;
    this.arrowLeftLabel = null;
    this.arrowRight = null;
    this.arrowRightlabel = null;
    this.items = null;
    this.header = null;
    this.buildArrows = this.buildArrows.bind(this);
    // this.buildBullets = this.buildBullets.bind(this);
    // this.updateBullets = this.updateBullets.bind(this);
    this.handleArrow = this.handleArrow.bind(this);
  }

  didMount() {
    this.items = this.element.querySelectorAll('.item-slider__slide');
    this.header = this.element.querySelector('.partners__title');
    this.arrowLeftLabel = this.header.getAttribute('data-arrow-left');
    this.arrowRightlabel = this.header.getAttribute('data-arrow-right');

    this.buildArrows();
    this.arrowLeft = this.element.querySelector('.item-slider__arrow--left');
    this.arrowRight = this.element.querySelector('.item-slider__arrow--right');

    // this.buildBullets();
    // this.bullets = this.element.querySelector('.item-slider__bullets');

    this.itemSlider = new Glide(this.element, this.props).mount();

    if (this.items.length > 1) {
      this.itemSlider.on('resize', () => {
        // this.itemSlider.go(0);

        // this.updateBullets();
        this.updateArrows();
      });

      this.arrowLeft.addEventListener('click', this.handleArrow);
      this.arrowRight.addEventListener('click', this.handleArrow);

      // this.updateBullets();
      this.updateArrows();
    }
  }

  willUnMount() {
    this.arrowLeft.removeEventListener('click', this.handleArrow);
    this.arrowRight.removeEventListener('click', this.handleArrow);
    this.itemSlider.destroy();
  }

  /**
   * Renders control arrows
   */
  buildArrows() {
    if (this.items.length > 1) {
      this.header.insertAdjacentHTML('beforebegin', `
      <button class="item-slider__arrow--left partners__button partners__button--left" aria-label="${this.arrowLeftLabel}" data-glide-dir="<">
        <svg class="partners__icon" xmlns="http://www.w3.org/2000/svg" width="11.871" height="10.009" viewBox="0 0 11.871 10.009">
            <path d="M13.108,17.388a.787.787,0,0,1,0-1.113l2.9-2.9H7.438C7.2,13.378,7,13.025,7,12.59s.2-.788.437-.788h8.519L13.108,8.954a.787.787,0,0,1,1.113-1.113l4.65,4.774-4.65,4.774a.788.788,0,0,1-1.113,0Z" transform="translate(18.871 17.618) rotate(180)"/>
        </svg>
      </button>`);

      this.header.insertAdjacentHTML('afterend', `
      <button class="item-slider__arrow--right partners__button partners__button--right" aria-label="${this.arrowRightlabel}" data-glide-dir=">">
        <svg class="partners__icon" xmlns="http://www.w3.org/2000/svg" width="11.871" height="10.008" viewBox="0 0 11.871 10.008">
            <path d="M13.108,17.388a.787.787,0,0,1,0-1.113l2.9-2.9H7.438C7.2,13.378,7,13.025,7,12.59s.2-.788.437-.788h8.519L13.108,8.954a.787.787,0,0,1,1.113-1.113l4.65,4.774-4.65,4.774a.788.788,0,0,1-1.113,0Z" transform="translate(-7 -7.61)"/>
        </svg>
      </button>
    </header>`);
    }
  }

  /**
   * Renders control bullets
   */
  buildBullets() {
    let item;

    if (this.items.length > 1) {
      let html = '<div class="item-slider__bullets" data-glide-el="controls[nav]">';
      for (const index in this.items) {
        if (this.items.hasOwnProperty(index)) {
          item = this.items[index];
          html += `<button class="item-slider__bullet item-slider__control" data-glide-dir="=${index}">${(item.getAttribute('data-webslider-title') || index)}</button>`;
        }
      }

      html += '\'</div>';
      this.element.innerHTML += html;
    }
  }

  updateBullets() {
    const perView = this.itemSlider.settings.perView;
    const pages = Math.ceil(this.items.length / perView);
    let page = 1;
    const buttons = this.bullets.querySelectorAll('button');

    for (let i = 0; i < buttons.length; i++) {
      if (((i % perView == 0) && (page <= pages)) || (((buttons.length - i) == perView))) {
        page++;

        buttons[i].classList.remove('hide');
      } else {
        buttons[i].classList.add('hide');
      }
    }
  }

  updateArrows() {
    /*    const perView = this.itemSlider.settings.perView;

    if (this.items.length <= perView) {
      this.arrowLeft.classList.add('hidden');
      this.arrowRight.classList.add('hidden');
      this.itemSlider.disable();
    } else {
      this.arrowLeft.classList.remove('hidden');
      this.arrowRight.classList.remove('hidden');
      this.itemSlider.enable();
    } */
  }

  handleArrow() {

  }
}

ItemSlider.defaultProps = {
  type: 'carousel',
  startAt: 0,
  perView: 8,
  focusAt: 0,
  gap: 10,
  autoplay: 4000,
  hoverpause: false,
  keyboard: false,
  bound: true,
  swipeThreshold: 80,
  dragThreshold: 120,
  perTouch: false,
  touchRatio: 0.5,
  touchAngle: 45,
  animationDuration: 400,
  rewind: false,
  rewindDuration: 800,
  animationTimingFunc: 'cubic-bezier(0, 0, 0, 0)',
  direction: 'ltr',
  peek: 0,
  throttle: 25,
  breakpoints: {
    480: {
      perView: 2,
    },
    768: {
      perView: 3,
    },
    992: {
      perView: 4,
    },
    1200: {
      perView: 6,
    },
  },
  classes: {
    direction: {
      ltr: 'item-slider--ltr',
      rtl: 'item-slider--rtl',
    },
    slider: 'item-slider--slider',
    carousel: 'item-slider--carousel',
    swipeable: 'item-slider--swipeable',
    dragging: 'item-slider--dragging',
    cloneSlide: 'item-slider__slide--clone',
    activeNav: 'item-slider__bullet--active',
    activeSlide: 'item-slider__slide--active',
    disabledArrow: 'item-slider__arrow--disabled',
  },
};

export default ItemSlider;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ItemSlider.js